class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = document.querySelector("#Search");
    this.predictiveSearchResults = this.querySelector("#predictive-search");
    this.loadingContainer = this.querySelector("#loading-container");
    this.initialContainer = document.querySelector("#initial-container");
    this.popularSearches = document.getElementById("popular-searches");

    this.toggleInitialContainer = (show) => {
      if (this.initialContainer) {
        this.initialContainer.style.display = show ? "block" : "none";
      }
    };

    this.toggleLoadingContainer = (show) => {
      if (this.loadingContainer) {
        this.loadingContainer.style.display = show ? "block" : "none";
      }
    };

    this.togglePredictiveSearchResults = (show) => {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.style.display = show ? "block" : "none";
      }
    };

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        const value = event.target.value.trim();
        this.toggleLoadingContainer(value.length > 0);
        this.toggleInitialContainer(value.length === 0);
        this.onChange(event);
      }, 300)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      if (this.popularSearches) this.popularSearches.style.display = "block";
      this.close();
      this.toggleLoadingContainer(false);
      this.toggleInitialContainer(true);
      return;
    }
    if (this.popularSearches) this.popularSearches.style.display = "none";
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html");
        const section = html.querySelector(
          "#shopify-section-predictive-search"
        );
        if (section && this.predictiveSearchResults) {
          this.predictiveSearchResults.innerHTML = section.innerHTML;
          this.open();
        } else {
          this.close();
        }
      })
      .catch(() => this.close())
      .finally(() => {
        this.toggleLoadingContainer(false);
        this.toggleInitialContainer(false);
      });
  }

  open() {
    this.togglePredictiveSearchResults(true);
  }

  close() {
    this.togglePredictiveSearchResults(false);
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

const setPredictiveSearch = () => {
  customElements.define("predictive-search", PredictiveSearch);
};
